import Editor from './base/editor';
import focusInput from '@intercom/embercom-composer/lib/focus-input';
import $ from 'jquery';
import { bool, not, or } from '@ember/object/computed';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Editor.extend({
  width: 330,
  keysToTriggerClose: [9, 13, 27],
  autoFocusSelector: 'input:first',
  hasFallback: bool('editableObject.fallback'),
  hasNoFallback: not('hasFallback'),
  classNames: ['is-light-theme', 'composer-attribute-fallback-editor'],
  //TODO: GJ: rename to composer-attribute-editor

  autoFocus() {
    let autoFocusSelector = this.get('autoFocusSelector');
    if (autoFocusSelector) {
      schedule('afterRender', this, function () {
        if (this.get('hasNoFallback')) {
          focusInput($(autoFocusSelector, this.element));
        }
      });
    }
  },
  flushChanges: Em.observer({
    dependentKeys: ['editableObject.fallback'],
    fn() {
      schedule('afterRender', this, function () {
        if (this.triggerDomUpdate) {
          this.triggerDomUpdate();
        }
      });
    },
    sync: true
  }),
  hideFallback: or('editableObject.isApp', 'editableObject.noFallback'),
  editorText: Em.computed('editableObject.name', function () {
    let userText = this.get('editableObject.isUser') ? "Recipient's " : '';
    let name = this.get('editableObject.isUser') ? this.get('editableObject.name').toLowerCase() : this.get('editableObject.name');
    return `${userText}${name} will be inserted here`;
  }),
  placeholderText: Em.computed('editableObject.name', function () {
    //TODO: GJ: one liner
    let name = this.get('editableObject.name');
    if (name) {
      return `If we can't find ${name.toLowerCase()}`;
    }
  })
});